module.exports = __webpack_public_path__ + "img/qr-top.55327c7e.png";